import * as React from "react";
import { ActiveIngredientAdminModel, ActiveIngredientFilterSettingsModel, ActiveIngredientGridModel, ActiveIngredientForGridModel }
  from "../../../models/activeIngredient";
import ActiveIngredientList from './activeIngredientList';
import ActiveIngredientService from '../../../services/activeIngredientService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { ActiveIngredientFilter } from './activeIngredientFilter';
import ActiveIngredientAddEditDialog from './activeIngredientAddEditDialog';
import { Lang } from '../../../common/enums';
import { ActiveIngredientContentModel } from '../../../models/activeIngredient/activeIngredientContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./activeIngredientsAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  activeIngredients: Array<ActiveIngredientForGridModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
  currentActiveIngredient: ActiveIngredientAdminModel;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  activeIngredientSettings: ActiveIngredientFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 20;

class ActiveIngredientContainer extends React.Component<IProps, IState> {
  activeIngredientService = new ActiveIngredientService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      activeIngredients: new Array<ActiveIngredientForGridModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
      currentActiveIngredient: new ActiveIngredientAdminModel(),
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      activeIngredientSettings: new ActiveIngredientFilterSettingsModel()
    };
  }

  // events
  componentDidMount() {
    this.getAllActiveIngredients(this.state.from, this.state.numberOfRows);
  }

  // handles
  handleAddAndEditClick = id => {
    if (!id) { // Add			
      let aciveIngredient = new ActiveIngredientAdminModel();

      let contentList = new Array<ActiveIngredientContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new ActiveIngredientContentModel();
        content.langId = parseInt(Lang[k]);
        content.description = '';
        content.shortDescription = '';
        contentList.push(content);
      });

      aciveIngredient.activeIngredientContent = contentList;

      this.setcurrentActiveIngredient(aciveIngredient);
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.activeIngredientService.getActiveIngredient(id)
        .then(
          (data: ActiveIngredientAdminModel) => {
            this.setcurrentActiveIngredient(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error,
              isLoading: false
            });
          }
        );
    }
  };

  getActiveIngredient = (id) => {
    this.activeIngredientService.getActiveIngredient(id)
      .then(
        (data: ActiveIngredientAdminModel) => {
          this.setcurrentActiveIngredient(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleDeleteClick = (id) => {
    this.getActiveIngredient(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteActiveIngredient(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.activeIngredientService.deleteActiveIngredient(id)
      .then(
        data => {
          this.getAllActiveIngredients(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSaveButton = (currentActiveIngredient: ActiveIngredientAdminModel, close: boolean) => {
    this.setState({
      isLoading: true
    });

    if (!currentActiveIngredient.activeIngredientId) { // Add
      this.activeIngredientService.addActiveIngredient(currentActiveIngredient)
        .then(
          (data) => {
            if (close) {
              this.showEditDialog(false);
            }
            this.setcurrentActiveIngredient(new ActiveIngredientAdminModel());
            this.getAllActiveIngredients(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentActiveIngredient(new ActiveIngredientAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.activeIngredientService.editActiveIngredient(currentActiveIngredient.activeIngredientId, currentActiveIngredient)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentActiveIngredient(new ActiveIngredientAdminModel());
            this.getAllActiveIngredients(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentActiveIngredient(new ActiveIngredientAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  // methods
  getAllActiveIngredients(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.activeIngredientService.getAllActiveIngredients(from, numberOfRows, this.state.activeIngredientSettings).then(
      (data: ActiveIngredientGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          activeIngredients: data.activeingredients,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  setcurrentActiveIngredient(activeIngredient: ActiveIngredientAdminModel) {
    this.setState({ currentActiveIngredient: { ...activeIngredient } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllActiveIngredients(startIndex, this.state.numberOfRows);
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.activeIngredientService.getAllActiveIngredients(initFrom, numberOfRows, settings).then(
      (data: ActiveIngredientGridModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          activeIngredients: data.activeingredients,
          activeIngredientSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  // render
  public render() {

    const { activeIngredients, isLoading, error } = this.state;

    return (
      <div>

        <h3>Active Ingredients</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        {this.state.isVisibleDialogWrap ? (
          <ActiveIngredientAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentActiveIngredient={this.state.currentActiveIngredient}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <button
            onClick={() => this.handleAddAndEditClick(null)}
            className="btn btn-success"
            style={{ marginRight: "5px" }}>
            Add New
          </button>
        </div>

        <ActiveIngredientFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
        />

        <ActiveIngredientList
          activeIngredients={activeIngredients}
          rows={numberOfRows}
          totalRecords={this.state.totalRecordsCount}
          onPageClick={this.handleOnPageClick}
          first={this.state.from}
          loading={Spinner}
          editClick={this.handleAddAndEditClick}
          deleteClick={this.handleDeleteClick}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteActiveIngredient(this.state.currentActiveIngredient.activeIngredientId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentActiveIngredient.activeIngredientName}"?
        </ConfirmDialog>
      </div>
    );
  }
}

export default ActiveIngredientContainer;